import { Pagination } from '@/api/pagination';
import { of, Observable, async } from 'rxjs';
import { map } from 'rxjs/operators';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { UsuarioAPI } from '@/api/usuario.api';
import { Usuario, PageUsuarioInput } from '@/models/usuario';

const api = new UsuarioAPI();

const show = (id: number): AxiosObservable<Usuario> => {
  return api.show(id);
}

const create = (usuario: any): AxiosObservable<Usuario> => {
  return api.create(usuario)
}

const update = (id: number, usuario: any): AxiosObservable<Usuario> => {
  return api.update(id, usuario)
}

const list = (params: any): Observable<any> => {
  return api.list(params);
}

export default {
  show,
  create,
  list,
  update
}
